import StyleSheet from 'react-native-media-query';

import constants from '../../Config/constants';
import { globalSpacing } from '../../Theme/styles';
import breakpoints from '../../Theme/styles/breakpoints';

export const { ids, styles } = StyleSheet.create({
  bannerContainer: constants.isWeb ? {} : { marginHorizontal: -globalSpacing },
  detailsContainer: {
    [`@media ${breakpoints.md}`]: {
      width: '82%',
    },
  },
  icon: {
    width: 24,
    height: 24,
  },
  borderRadius: { borderRadius: 13 },
});
